import "core-js/modules/es6.function.name";
import TagExtendComponent from "./index.vue";
var TagExtend = {
  install: function install(Vue) {
    Vue.component('yk-' + TagExtendComponent.name, TagExtendComponent);
  },
  key: TagExtendComponent.name
};
export default TagExtend;